export const Academy = () => {
  return (
    <div className="container" style={{ paddingTop: '24px' }}>
      <h1>Академия</h1>
      <p>Образовательные материалы...</p>
    </div>
  );
};